// extracted by mini-css-extract-plugin
export default {"wrap":"bottomNavigation_wrap__k35Fl","center":"bottomNavigation_center__2sPxM","item":"bottomNavigation_item__bRjBQ"};